import { InteractionsServiceConstants } from "@agentx/agentx-services";
export var TasksType;
(function (TasksType) {
    TasksType["Active"] = "active";
    TasksType["Queued"] = "queued";
    TasksType["Scheduled"] = "scheduled";
    TasksType["Closed"] = "closed";
})(TasksType || (TasksType = {}));
export var TaskAssignErrorType;
(function (TaskAssignErrorType) {
    TaskAssignErrorType["TASK_NO_LONGER_AVAILABLE"] = "TASK_NO_LONGER_AVAILABLE";
    TaskAssignErrorType["ASSIGN_FAILED"] = "ASSIGN_FAILED";
    TaskAssignErrorType["ACCEPT_FAILED"] = "ACCEPT_FAILED";
    TaskAssignErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(TaskAssignErrorType || (TaskAssignErrorType = {}));
export const SortOrder = {
    Ascending: "asc",
    Descending: "desc",
    Unsorted: null
};
export const SortableQueuedField = {
    Priority: InteractionsServiceConstants.QueryField.ContactPriority,
    CustomerName: InteractionsServiceConstants.QueryField.CustomerName,
    CreatedTime: InteractionsServiceConstants.QueryField.CreatedTime,
    QueueName: InteractionsServiceConstants.QueryField.QueueName
};
